import memoizeOne from 'memoize-one';

import type { LayoutPluginOptions } from '@atlaskit/editor-common/types';

export const getLayoutOptions = memoizeOne(
	(): LayoutPluginOptions => ({
		allowBreakout: true,
		UNSAFE_addSidebarLayouts: true,
	}),
);
